import Request from '@/api/request';

export interface IRegion {
  regionName: string;
  regionCode: string;
}

const api = new Request('lk/profile/');

export function saveDocument(data: object): Promise<object> {
  return api.post('saveDocument', data).then((res: any) => {
    return res;
  });
}

export function getUserDocuments(documentType?: string): Promise<any> {
  return documentType
    ? api
        .get(`getUserDocuments?documentType=${documentType}`)
        .then((res: any) => {
          return res;
        })
    : api.get(`getUserDocuments`).then((res: any) => {
        return res;
      });
}

export function deleteUserDocument(documentId?: string): Promise<any> {
  return api
    .delete(`deleteUserDocument?documentId=${documentId}`)
    .then((res: any) => {
      return res;
    });
}

export function saveBankDetails(data: object): Promise<any> {
  return api.post(`saveBankDetails`, data).then((res: any) => {
    return res;
  });
}

export function getBankDetails(): Promise<any> {
  return api.get('getBankDetails').then((res: any) => {
    return res;
  });
}

export function deleteBankDetails(bankDetailId: string): Promise<any> {
  return api
    .delete(`deleteBankDetails?bankDetailId=${bankDetailId}`)
    .then((res: any) => {
      return res;
    });
}
